import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useInternational } from '@/common/locale';
import { useViewModeStore } from '@/common/stores/view-mode';
import { getVersion } from '@/common/utils/commonUtils';
import { EXEM_ONE_DOCS_LINK } from '@/common/utils/externalLinkUrl.define';
import { VIEW_MODE_SERVICE } from '../../baseMenu.define';

interface ModuleInfo {
  title: string;
  version: string;
  category: 'system' | 'k8s' | 'application' | 'database';
}

interface FileInfo {
  label: string;
  path: string;
  name: string;
}

export const setup = () => {
  const { t } = useInternational();
  const { viewMode, isMaxgaugeMode } = storeToRefs(useViewModeStore());

  const moduleVersion = computed(() => getVersion());

  const moduleInfoList = computed<ModuleInfo[]>(() => {
    const version = getVersion();
    const currentViewMode = t(`WORD.${viewMode.value.toUpperCase()}`);

    const modules: ModuleInfo[] = [
      {
        title: t('WORD.GNB.HELP.SYSTEM_MODULE_VERSION', { version: '', viewMode: currentViewMode }),
        version,
        category: 'system',
      },
      {
        title: t('WORD.GNB.HELP.K8S_MODULE_VERSION', { version: '', viewMode: currentViewMode }),
        version,
        category: 'k8s',
      },
      {
        title: t('WORD.GNB.HELP.APPLICATION_MODULE_VERSION', {
          version: '',
          viewMode: currentViewMode,
        }),
        version,
        category: 'application',
      },
      {
        title:
          viewMode.value === 'exemone'
            ? t('WORD.GNB.HELP.DATABASE_MODULE_VERSION', {
                version: '',
                viewMode: currentViewMode,
              })
            : t('WORD.GNB.HELP.VIEW_MODE_MODULE_VERSION', {
                version: '',
                viewMode: currentViewMode,
              }),
        version,
        category: 'database',
      },
    ];

    return modules.filter((module) => VIEW_MODE_SERVICE[viewMode.value]?.includes(module.category));
  });

  const fileInfoList = computed<FileInfo[]>(() => {
    const baseFiles: FileInfo[] = [
      // {
      //   label: t('WORD.GNB.HELP.PRODUCT_INTRODUCTION_DOWNLOAD'),
      //   path: `/support/${locale.value}/product_introduction.pdf`,
      //   name: `exemONE_${t('WORD.PRODUCT_INTRODUCTION')}.pdf`,
      // },
      // {
      //   label: t('WORD.GNB.HELP.USER_GUIDE_DOWNLOAD'),
      //   path: `/support/${locale.value}/user_guide.pdf`,
      //   name: `exemONE_${t('WORD.USER_GUIDE')}.pdf`,
      // },
      {
        label: t('WORD.GNB.HELP.OPENAPI_GUIDE'),
        path: '/support/exemOne_openapi_guide.pdf',
        name: `exemONE_${t('WORD.OPENAPI_GUIDE')}.pdf`,
      },
    ];

    const maxgaugeFiles: FileInfo[] = isMaxgaugeMode.value
      ? [
          {
            label: t('WORD.GNB.HELP.EXEMONE_MANUAL'),
            path: '/support/exemOne_maxgauge_manual.pdf',
            name: `exemONE_${t('WORD.EXEMONE_MANUAL')}.pdf`,
          },
        ]
      : [];

    return [...maxgaugeFiles, ...baseFiles];
  });

  const onClickViewManual = () => {
    window.open(EXEM_ONE_DOCS_LINK, '_blank', 'noopener,noreferrer');
  };

  return {
    t,
    isMaxgaugeMode,
    moduleInfoList,
    fileInfoList,
    onClickViewManual,
    moduleVersion,
  };
};
